import { render, staticRenderFns } from "./wt-tab.vue?vue&type=template&id=e7ac1008"
import script from "./wt-tab.vue?vue&type=script&lang=js"
export * from "./wt-tab.vue?vue&type=script&lang=js"
import style0 from "./wt-tab.vue?vue&type=style&index=0&id=e7ac1008&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports